import { render, staticRenderFns } from "./OrderTypeExtra.vue?vue&type=template&id=1042a89b"
import script from "./OrderTypeExtra.vue?vue&type=script&lang=js"
export * from "./OrderTypeExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports